var map = {
	"./fabric.color.variables.theme.angular.json": 4592,
	"./fabric.color.variables.theme.backpack.json": 4593,
	"./fabric.color.variables.theme.balloons.json": 4594,
	"./fabric.color.variables.theme.base.dark.json": 4595,
	"./fabric.color.variables.theme.base.json": 1371,
	"./fabric.color.variables.theme.basewithofficethemepreferred.json": 4596,
	"./fabric.color.variables.theme.beach.json": 4597,
	"./fabric.color.variables.theme.black.json": 4598,
	"./fabric.color.variables.theme.blueberry.json": 4599,
	"./fabric.color.variables.theme.blueprint.json": 4600,
	"./fabric.color.variables.theme.bricks.json": 4601,
	"./fabric.color.variables.theme.cats.json": 4602,
	"./fabric.color.variables.theme.chevron.json": 4603,
	"./fabric.color.variables.theme.circuit.json": 4604,
	"./fabric.color.variables.theme.comic.json": 4605,
	"./fabric.color.variables.theme.contrast.json": 4606,
	"./fabric.color.variables.theme.cordovan.json": 4607,
	"./fabric.color.variables.theme.crayon.json": 4608,
	"./fabric.color.variables.theme.cubes.json": 4609,
	"./fabric.color.variables.theme.cubism.json": 4610,
	"./fabric.color.variables.theme.darkcordovan.json": 4611,
	"./fabric.color.variables.theme.darkorange.json": 4612,
	"./fabric.color.variables.theme.diamonds.json": 4613,
	"./fabric.color.variables.theme.far.json": 4614,
	"./fabric.color.variables.theme.grape.json": 4615,
	"./fabric.color.variables.theme.jelly.json": 4616,
	"./fabric.color.variables.theme.lightblue.json": 4617,
	"./fabric.color.variables.theme.lightgreen.json": 4618,
	"./fabric.color.variables.theme.lite.json": 4619,
	"./fabric.color.variables.theme.mediumdarkblue.json": 4620,
	"./fabric.color.variables.theme.minimal.json": 4621,
	"./fabric.color.variables.theme.modern.json": 4622,
	"./fabric.color.variables.theme.mountain.json": 4623,
	"./fabric.color.variables.theme.orange.json": 4624,
	"./fabric.color.variables.theme.paint.json": 4625,
	"./fabric.color.variables.theme.pink.json": 4626,
	"./fabric.color.variables.theme.pixel.json": 4627,
	"./fabric.color.variables.theme.polka.json": 4628,
	"./fabric.color.variables.theme.pomegranate.json": 4629,
	"./fabric.color.variables.theme.primary.json": 4630,
	"./fabric.color.variables.theme.raspberry.json": 4631,
	"./fabric.color.variables.theme.robot.json": 4632,
	"./fabric.color.variables.theme.simple.json": 4633,
	"./fabric.color.variables.theme.spectrum.json": 4634,
	"./fabric.color.variables.theme.strawberry.json": 4635,
	"./fabric.color.variables.theme.super.json": 4636,
	"./fabric.color.variables.theme.supplies.json": 4637,
	"./fabric.color.variables.theme.teagarden.json": 4638,
	"./fabric.color.variables.theme.teal.json": 4639,
	"./fabric.color.variables.theme.unicorn.json": 4640,
	"./fabric.color.variables.theme.watermelon.json": 4641,
	"./fabric.color.variables.theme.whale.json": 4642,
	"./fabric.color.variables.theme.whimsical.json": 4643,
	"./fabric.color.variables.theme.wntrlnd.json": 4644,
	"./fabric.color.variables.theme.wrld.json": 4645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4591;